import { render, staticRenderFns } from "./RewardToRedeemItem.vue?vue&type=template&id=0d018e5c&scoped=true&lang=pug&"
import script from "./RewardToRedeemItem.vue?vue&type=script&lang=js&"
export * from "./RewardToRedeemItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d018e5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio})
